import clone from 'lodash/clone'

export default {
  inheritAttrs: false,
  props: [
    'name',
    'id',
    'required',
    'dataNetteRules',
    'type',
    'disabled'
  ],
  computed: {
    val: {
      get() {
        return this.$controls[this.id].val
      },
      set(val) {
        this.$formValues[this.id] = val
      }
    },
    attrs () {
      const attrs = clone(this.$attrs)
      if ('value' in attrs)
        delete attrs.value
      
      return attrs
    }
  }
}
